<template>
  <div>
    <footer class="main-footer mobile-footer">
      <div class="d-none d-sm-block">
        <strong
          >{{ new Date().getFullYear() }} &copy;
          <a href="https://dotlines.com.bd/">Dotlines</a>.</strong
        >
        All rights reserved.
      </div>
      <div class="d-block d-sm-none position-relative">
        <div class="mobile-nav-bar-overlay" v-if="is_menu_loading"></div>
        <nav class="mobile-nav-bar">
          <ul>
            <li
              @click="activate(m_nav.id)"
              :class="{ active: active_el == m_nav.id }"
              v-for="m_nav in menu_list"
              :key="m_nav.id"
            >
              <router-link :to="m_nav.route">
                <!-- <i :class="m_nav.icon"></i>  -->
                <div class="footer-icon">
                  <div class="footer-icon-svg">
                    <svg>
                      <use :xlink:href="'#' + m_nav.icon + '-line'"></use>
                    </svg>
                  </div>
                  <div class="footer-icon-svg">
                    <svg>
                      <use :xlink:href="'#' + m_nav.icon"></use>
                    </svg>
                  </div>
                </div>
                {{ m_nav.menu }}
              </router-link>
            </li>
            <li :class="{ open: show }">
              <a class="hamburger-icon" href="javascripit:void(0);" @click="show = !show">
                <div class="footer-icon">
                  <div class="footer-icon-svg">
                    <svg>
                      <use xlink:href="#footer-icon-menu-line"></use>
                    </svg>
                  </div>
                  <div class="footer-icon-svg">
                    <svg>
                      <use xlink:href="#footer-icon-menu-line"></use>
                    </svg>
                  </div>
                </div>
                More</a
              >
            </li>
            <div class="indicator"></div>
          </ul>
        </nav>
      </div>
    </footer>
    <nav class="mobile-menu d-block d-sm-none">
      <h3>
        <img src="/assets/images/logo.svg" alt="" />
        <a class="hamburger-icon icon-close" href="javascripit:void(0);"></a>
      </h3>
      <!-- <ul>
        <li class="nav__item">
          <a href="/admin/dashboard" class="nav__link"
            ><i class="nav-icon fas fa-chart-area"></i>
            <span> Dashboard </span></a
          >
        </li>
        <li class="nav__item">
          <a href="javascript:void(0)" class="nav__link"
            ><i class="nav-icon fas fa-tasks"></i>
            <span>Admin <i class="right icon-right"></i></span
          ></a>
          <ul class="nav__sub">
            <li class="nav__item">
              <a href="/admin/auth/users" class="nav__link"
                ><i class="fas nav-icon fa-arrow-alt-circle-right"></i>
                <span>Users</span></a
              >
            </li>
            <li class="nav__item">
              <a href="/admin/auth/roles" class="nav__link"
                ><i class="fas nav-icon fa-arrow-alt-circle-right"></i>
                <span>Roles</span></a
              >
            </li>
            <li class="nav__item">
              <a href="/admin/auth/permissions" class="nav__link"
                ><i class="fas nav-icon fa-arrow-alt-circle-right"></i>
                <span>Permission</span></a
              >
            </li>
            <li class="nav__item">
              <a href="/admin/auth/menu" class="nav__link"
                ><i class="fas nav-icon fa-bars"></i> <span>Menu</span></a
              >
            </li>
            <li class="nav__item">
              <a href="/admin/auth/logs" class="nav__link"
                ><i class="fas nav-icon fa-history"></i>
                <span>Operation log</span></a
              >
            </li>
            <li class="nav__item">
              <a
                href="/admin/ext-dotlines-admin/organizations"
                class="nav__link"
                ><i class="fas nav-icon fa fa-bars"></i>
                <span>Organizations</span></a
              >
            </li>
          </ul>
        </li>

        <li class="nav__item">
          <a href="javascript:void(0)" class="nav__link"
            ><i class="nav-icon fas fa-bars"></i>
            <span
              >Organization Management
              <i class="right icon-right"></i></span
          ></a>
          <ul class="nav__sub">
            <li class="nav__item">
              <a href="/admin/custom_departments" class="nav__link"
                ><i class="fas nav-icon fa-android"></i>
                <span>Departments</span></a
              >
            </li>
            <li class="nav__item">
              <a href="/admin/week_names" class="nav__link"
                ><i class="fas nav-icon fa-bars"></i>
                <span>Week Dropright</span></a
              >
            </li>
            <li class="nav__item">
              <a href="/admin/employee_designations" class="nav__link"
                ><i class="fas nav-icon fa-bars"></i>
                <span>Designation</span></a
              >
            </li>
            <li class="nav__item">
              <a href="/admin/emp_functional_designations" class="nav__link"
                ><i class="fas nav-icon fa-bars"></i>
                <span>Functional Designations</span></a
              >
            </li>
            <li class="nav__item">
              <a href="/admin/emp_sbus" class="nav__link"
                ><i class="fas nav-icon fa-bars"></i> <span>SBU</span></a
              >
            </li>
            <li class="nav__item">
              <a href="/admin/company_divisions" class="nav__link"
                ><i class="fas nav-icon fa-bars"></i> <span>Division</span></a
              >
            </li>
            <li class="nav__item">
              <a href="/admin/company_units" class="nav__link"
                ><i class="fas nav-icon fa-bars"></i> <span>Unit</span></a
              >
            </li>
            <li class="nav__item">
              <a href="/admin/religions" class="nav__link"
                ><i class="fas nav-icon fa-bars"></i> <span>Religion</span></a
              >
            </li>
            <li class="nav__item">
              <a href="/admin/project_roles" class="nav__link"
                ><i class="fas nav-icon fa-bars"></i>
                <span>Project Role</span></a
              >
            </li>
            <li class="nav__item">
              <a href="/admin/holiday_names" class="nav__link"
                ><i class="fas nav-icon fa-bars"></i>
                <span>Holiday Name</span></a
              >
            </li>
            <li class="nav__item">
              <a href="/admin/holiday_lists" class="nav__link"
                ><i class="fas nav-icon fa-bars"></i>
                <span>Holiday List</span></a
              >
            </li>
            <li class="nav__item">
              <a href="/admin/teams" class="nav__link"
                ><i class="fas nav-icon fa-bars"></i> <span>Team</span></a
              >
            </li>
            <li class="nav__item">
              <a href="/admin/project_types" class="nav__link"
                ><i class="fas nav-icon fa-bars"></i>
                <span>Project Type</span></a
              >
            </li>
            <li class="nav__item">
              <a href="/admin/working_profile_types" class="nav__link"
                ><i class="fas nav-icon fa-align-justify"></i>
                <span>Working Pofile</span></a
              >
            </li>
          </ul>
        </li>
        <li class="nav__item">
          <a href="javascript:void(0)" class="nav__link"
            ><i class="nav-icon fas fa-user-md"></i>
            <span>Employee <i class="right fas fa-angle-right"></i></span
          ></a>
          <ul class="nav__sub">
            <li class="nav__item">
              <a href="/admin/employee_profile_infos" class="nav__link"
                ><i class="fas nav-icon fa-bars"></i>
                <span>Employee Profile Info</span></a
              >
            </li>
          </ul>
        </li>
        <li class="nav__item">
          <a href="javascript:void(0)" class="nav__link"
            ><i class="nav-icon fas fa-project-diagram"></i>
            <span
              >Project Management <i class="right fas fa-angle-right"></i></span
          ></a>
          <ul class="nav__sub">
            <li class="nav__item">
              <a href="/admin/projects" class="nav__link"
                ><i class="fas nav-icon fa-bars"></i> <span>Project</span></a
              >
            </li>
            <li class="nav__item">
              <a href="/admin/project_features" class="nav__link"
                ><i class="fas nav-icon fa-bars"></i>
                <span>Features / Objectives</span></a
              >
            </li>
            <li class="nav__item">
              <a href="/admin/project_meetings" class="nav__link"
                ><i class="fas nav-icon fa-bars"></i>
                <span>Project Meeting</span></a
              >
            </li>
            <li class="nav__item">
              <a href="/admin/project_milestones" class="nav__link"
                ><i class="fas nav-icon fa-bars"></i> <span>Milestone</span></a
              >
            </li>
            <li class="nav__item">
              <a href="/admin/project_members" class="nav__link"
                ><i class="fas nav-icon fa-bars"></i> <span>Member</span></a
              >
            </li>
            <li class="nav__item">
              <a href="/admin/tasks" class="nav__link"
                ><i class="fas nav-icon fa-bars"></i> <span>Task</span></a
              >
            </li>
          </ul>
        </li>
        <li class="nav__item">
          <a href="javascript:void(0)" class="nav__link"
            ><i class="nav-icon fas fa-bars"></i>
            <span>Leave <i class="right fas fa-angle-right"></i></span
          ></a>
          <ul class="nav__sub">
            <li class="nav__item">
              <a href="/admin/employee_leave_details" class="nav__link"
                ><i class="fas nav-icon fa-bars"></i>
                <span>Leave Profile</span></a
              >
            </li>
            <li class="nav__item">
              <a href="/admin/employee_leave_profiles" class="nav__link"
                ><i class="fas nav-icon fa-bars"></i>
                <span>Leave Requests</span></a
              >
            </li>
          </ul>
        </li>

        <li class="nav__item">
          <a href="/admin/auth/ext/change-password" class="nav__link"
            ><i class="nav-icon fas fa-unlock"></i>
            <span> Change Password </span></a
          >
        </li>
        <li class="nav__item">
          <a href="javascript:void(0)" class="nav__link"
            ><i class="nav-icon fas fa-bars"></i>
            <span>Report <i class="right fas fa-angle-right"></i></span
          ></a>
          <ul class="nav__sub">
            <li class="nav__item">
              <a
                href="/admin/report/grid/reportdepartmentwise"
                class="nav__link"
                ><i class="fas nav-icon fa-bars"></i>
                <span>Department Wise Resource</span></a
              >
            </li>
            <li class="nav__item">
              <a href="/admin/report/grid/project-wise-task" class="nav__link"
                ><i class="fas nav-icon fa-bars"></i>
                <span>Project Wise Task and Member</span></a
              >
            </li>
          </ul>
        </li>
        <li class="nav__item">
          <a href="javascript:void(0)" class="nav__link"
            ><i class="nav-icon fas fa-users"></i>
            <span>Recruitment <i class="right fas fa-angle-right"></i></span
          ></a>
          <ul class="nav__sub">
            <li class="nav__item">
              <a href="/admin/resource_requisitions" class="nav__link"
                ><i class="fas nav-icon fa-user-plus"></i>
                <span>Resource Requisition</span></a
              >
            </li>
          </ul>
        </li>

        <li class="nav__item">
          <a href="javascript:void(0)" class="nav__link"
            ><i class="nav-icon fas fa-fighter-jet"></i>
            <span>Attendance <i class="right fas fa-angle-right"></i></span
          ></a>
          <ul class="nav__sub">
            <li class="nav__item">
              <a href="/admin/attendence_requests" class="nav__link"
                ><i class="fas nav-icon fa-bars"></i>
                <span>Attendance Request</span></a
              >
            </li>
          </ul>
        </li>
        <li class="nav__item">
          <a href="javascript:void(0)" class="nav__link"
            ><i class="nav-icon fas fa-bars"></i>
            <span>PPF <i class="right fas fa-angle-right"></i></span
          ></a>
          <ul class="nav__sub">
            <li class="nav__item">
              <a href="/admin/ppf_criteria_sets" class="nav__link"
                ><i class="fas nav-icon fa-address-card"></i>
                <span>PPF Criteria Set</span></a
              >
            </li>
            <li class="nav__item">
              <a href="/admin/ppf_criteria_banks" class="nav__link"
                ><i class="fas nav-icon fa-atom"></i>
                <span>Criteria Bank</span></a
              >
            </li>
            <li class="nav__item">
              <a href="/admin/ppf_request_lists" class="nav__link"
                ><i class="fas nav-icon fa-bars"></i>
                <span>Request List</span></a
              >
            </li>
            <li class="nav__item">
              <a href="/admin/ppf_evaluation_periods" class="nav__link"
                ><i class="fas nav-icon fa-bars"></i>
                <span>Evaluation Period</span></a
              >
            </li>
            <li class="nav__item">
              <a href="/admin/ppf_form_lists" class="nav__link"
                ><i class="fas nav-icon fa-bars"></i> <span>Form List</span></a
              >
            </li>
            <li class="nav__item">
              <a href="/admin/ppf_score_list" class="nav__link"
                ><i class="fas nav-icon fa-bars"></i>
                <span>PPF Score List</span></a
              >
            </li>
          </ul>
        </li>
      </ul> -->

      <ul>
        <li
          class="nav__item"
          v-for="(item, index) in menuItems"
          v-if="!ignore_route.includes(item.title)"
        >
          <router-link
            v-if="!_.isEmpty(item.uri) && _.isEmpty(item.children)"
            :to="'/admin/' + (item.uri == '/' ? '' : item.uri)"
            class="nav__link"
          >
            <i
              v-if="!_.isEmpty(item.icon)"
              class="nav-icon fas"
              v-bind:class="item.icon"
            ></i>
            <i v-else class="far fa-circle nav-icon"></i>
            <span>
              {{ item.title }}
              <i v-if="!_.isEmpty(item.children)" class="right icon-right"></i>
            </span>
          </router-link>
          <a v-else href="javascript:void(0)" class="nav__link">
            <i
              v-if="!_.isEmpty(item.icon)"
              class="nav-icon fas"
              v-bind:class="item.icon"
            ></i>
            <i v-else class="nav-icon fas fa-circle"></i>
            <span>
              {{ item.title }}
              <i v-if="!_.isEmpty(item.children)" class="right icon-right"></i>
            </span>
          </a>
          <ul class="nav__sub" v-if="!_.isEmpty(item.children)">
            <li
              class="nav__item"
              v-for="(itemChild, childIndex) in item.children"
              v-if="!ignore_route.includes(itemChild.title)"
            >
              <router-link
                v-if="!_.isEmpty(itemChild.uri) && _.isEmpty(itemChild.children)"
                :to="'/admin/' + itemChild.uri"
                class="nav__link"
              >
                <!-- <i
                  v-if="!_.isEmpty(itemChild.icon)"
                  class="fas nav-icon "
                  v-bind:class="itemChild.icon"
                ></i> -->
                <i class="fas fa-circle nav-icon"></i>
                <span>{{ itemChild.title }}</span>
              </router-link>
              <a v-else href="javascript:void(0)" class="nav__link">
                <!-- <i
                  v-if="!_.isEmpty(itemChild.icon)"
                  class="nav-icon fas"
                  v-bind:class="itemChild.icon"
                ></i> -->
                <i class="nav-icon fas fa-circle"></i>
                <span>
                  {{ itemChild.title }}
                  <i v-if="!_.isEmpty(itemChild.children)" class="right icon-right"></i>
                </span>
              </a>
              <ul class="nav__sub" v-if="!_.isEmpty(itemChild.children)">
                <li
                  class="nav__item"
                  v-for="(itemGrandChild, grandChildIndex) in itemChild.children"
                >
                  <router-link
                    v-if="!_.isEmpty(itemGrandChild.uri)"
                    :to="'/admin/' + itemGrandChild.uri"
                    class="nav__link"
                  >
                    <!-- <i
                      v-if="!_.isEmpty(itemGrandChild.icon)"
                      class="fas nav-icon"
                      v-bind:class="itemGrandChild.icon"
                    ></i> -->
                    <i class="fas fa-circle nav-icon"></i>
                    <span>{{ itemGrandChild.title }}</span>
                  </router-link>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
    </nav>
  </div>
</template>
<style></style>
<script>
import $ from "jquery";
import { mapGetters } from "vuex";

export default {
  props: ["menuItems"],
  data: () => ({
    menu_list: [
      { id: "1", menu: "Home", icon: "footer-icon-apps", route: "/" },
      {
        id: "2",
        menu: "Groups",
        icon: "footer-icon-device",
        route: "/admin/group_info",
      },
      {
        id: "3",
        menu: "Reports",
        icon: "footer-icon-report",
        route: "/admin/summary_usages",
      },
    ],
    active_el: 0,
    show: false,
    showChild: false,
    showMobileMenu: false,
    curretMenuName: "Back",
    // menuItems: [],
    user_detail: {},
    ignore_route: [],
    is_menu_loading: true,
  }),
  computed: {
    ...mapGetters(["profile"]),
  },
  watch: {
    profile: function (newUser, oldUser) {
      if (!_.isEmpty(newUser)) {
        this.user_detail = newUser;
      }
    },
    menuItems: function (newVal, oldVal) {
      if (!_.isEmpty(newVal)) {
        setTimeout(() => this.menuItemjs(), 300);
      }
    },
  },
  mounted: function () {
    window.scrollTo(0, 0);

    // eslint-disable-next-line no-undef
    // if (_.isEmpty(this.profile)) {
    //   await CommonAPI.getProfile().then((profile_info) => {
    //     this.user_detail = profile_info;
    //     // console.log(profile_info);
    //   });
    // } else {
    //   this.user_detail = this.profile;
    // }

    // console.log(this.isMobile());

    // console.log('this.profile', this.profile)
    if (this.isMobile()) {
      this.ignore_route = [];
    } else {
      if (
        !_.isEmpty(this.user_detail) &&
        (this.user_detail.roles[0].id === 1 ||
          this.user_detail.roles[0].id === 3 ||
          this.user_detail.roles[0].id === 4)
      ) {
        // console.log('ignore route for ppf user');
        this.ignore_route = [];
      } else {
        // console.log('ignore route for normal user');

        this.ignore_route = [];
      }
    }
    // $(window).trigger("resize");

    // // window.$('ul[data-widget="treeview"]').Treeview("init");
    // await this.getMenuItems();

    this.$nextTick(() => {
      if (this.menuItems && this.menuItems.length) {
        this.menuItemjs();
      }
    });
  },
  methods: {
    // getMenuItems: function () {
    //   Menu.getAllMenus()
    //     .then((menus) => {
    //       // console.log(menus)
    //       this.menuItems = menus;
    //     })
    //     .catch((e) => {
    //       console.log("errrr", e);
    //     })
    //     .finally(() => {
    //       this.menuItemjs();
    //     });
    // },

    getMenuItems: function () {},

    activate: function (el) {
      this.active_el = el;
    },
    menuItemjs: function () {
      setTimeout(function () {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const _this = this;
        $(".sub__close").remove();
        // $('.nav__sub').prepend('<li class="nav__item"><a class="nav__link sub__close" href="javascript:void(0)"><i class="fas fa-chevron-left"></i>' + (_this.curretMenuName === undefined) ? 'Back' : _this.curretMenuName + '</a></li>');
        $(".nav__sub").prepend(
          '<li class="nav__item"><a class="nav__link sub__close" href="javascript:void(0)"><i class="icon-left"></i>' +
            (_this.curretMenuName === undefined ? "Back" : _this.curretMenuName) +
            "</a></li>"
        );

        $(".sub__close").click(function (e) {
          // console.log('closing')
          e.preventDefault();
          $(this).parent().parent().removeClass("is-active");
        });

        $(".nav__link").click(function (e) {
          e.preventDefault();
          $(this).siblings().addClass("is-active");
        });

        $(".mobile-menu ul .nav__item a[href!='javascript:void(0)']").on(
          "click",
          function (e) {
            // console.log('closing in sub');
            $(".mobile-menu").removeClass("is-open");
            $(".mobile-nav-bar ul li").removeClass("active");
            $(".nav__sub").removeClass("is-active");
            e.preventDefault();
          }
        );

        $(".hamburger-icon").on("click", function (e) {
          $(".mobile-menu").toggleClass("is-open");
          e.preventDefault();
        });
      }, 1000);
      this.is_menu_loading = false;
    },
  },
};
</script>
